import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Switch, Route } from "react-router-dom";
import { getAdminBasePath, getAdminBaseRoute } from "../AdminRoutes";
import CourseSectionList from "./CourseSectionList";
import CourseSectionDetail from "./CourseSectionDetail";
import CourseSectionEdit from "./CourseSectionEdit";
import SEO from "../../../UI/SEO/SEO";
export const getCourseSectionBasePath = () => getAdminBasePath() + "/courseSection";
export const getCourseSectionBaseRoute = () => getAdminBaseRoute() + "/courseSection";
export const getCourseSectionIndexRoute = () => getCourseSectionBaseRoute();
export const getCourseSectionIndexPath = () => getCourseSectionBasePath();
export const getCourseSectionDetailPath = (id) => getCourseSectionBasePath() + `/${id}`;
export const getCourseSectionDetailRoute = () => getCourseSectionBaseRoute() + "/:id";
export const getCourseSectionEditPath = (id) => getCourseSectionBasePath() + `/edit/${id}`;
export const getCourseSectionEditRoute = () => getCourseSectionBaseRoute() + "/edit/:id";
const AdminCourseSectionRoutes = () => {
    return (_jsxs(_Fragment, { children: [_jsx(SEO, { title: "Course Sections" }), _jsxs(Switch, { children: [_jsx(Route, { component: CourseSectionEdit, path: getCourseSectionEditRoute() }), _jsx(Route, { component: CourseSectionDetail, path: getCourseSectionDetailRoute() }), _jsx(Route, { component: CourseSectionList, path: getCourseSectionIndexRoute() })] })] }));
};
export default AdminCourseSectionRoutes;
